module.exports = __webpack_public_path__ + "static/img/3-1.41af966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/335/3-1.jpg
// module id = sn2V
// module chunks = 0